import * as z from "zod";

export const deleteWorkOrderFlow = {
  name: "deleteWorkOrderFlow" as const,
  input: z.object({ flowId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
